const vars = {
  fontFamily: "'IBM Plex Sans', sans-serif",
  primaryColor: '#4c276a',
  primaryBgColor: '#1C1C1C',
  gutter: '16px',
  buttonOutlineColor: '#222222',
  headerBgColor: '#000',
  buttonOrange: '#fc6320',
  primaryTextColor: 'rgba(255, 255, 255, 0.8)',
  radius: '6px',
  whiteTextColor: '#ffffff',
  filtersBgColor: '#323232',
  subHeaderBg: '#282828',
  subHeaderHeadingColor: '#F2F2F7',
  dividerBackgroundColor: 'rgba(255, 255, 255, 0.3)',
  borderColor: 'rgba(255, 255, 255, 0.1)',
  paragraphColor: 'rgba(242, 242, 247, 0.6)',
  transition: 'all ease-in-out .3s',
  modalTextColor: '#161616',
  modalBorderColor: '#E5E5E5',
  lightBlackColor: 'rgba(0, 0, 0, 0.8)',
  captionTextColor: 'rgba(0, 0, 0, 0.5)',
  toolbarBackground: 'rgba(255,0,0,0.5)',
  menuPaperBG: 'rgba(0, 0, 0, 0.1)',
  filterShadowColor: 'rgba(0, 0, 0, 0.7)',
  scrollBarBg: 'rgba(0,0,0,0.24)',
  outlinedBorderColor: 'rgba(255, 255, 255, 0.4)',
  listHoverBg: 'rgba(76, 39, 106, 0.10)',
  inputShadow: 'rgba(76, 39, 106, 0.15)',
  sliderBorderColor: 'rgba(0, 0, 0, 0.1)',
  treeItemActiveColor: 'rgba(76, 39, 106, 0.1)',
  blackColor: '#000000',
  tabBackgroundColor: '#F0EFEF',
  filterButtonBg: '#F2F2F2',
  downloadBgColor: 'rgba(229, 229, 229, 0.4)',
  downloadBorderColor: 'rgba(229, 229, 229, 0.3)',
  buttonConfirmationColor: '#F24822',
  selectedBgColor: '#F2EBF5',
  selectedHoverBgColor: '#ECDFF2',
  selectedExpandedBgColor: '#F9F5FA',
};

export default vars;
